import React, {useEffect, useImperativeHandle, useState} from 'react';
import _ from 'lodash'
import {useDispatch, useSelector} from 'react-redux';
import '../../styles/kyc.css';
import Popup from "../Popup";
import DocumentViewer from '../DocumentViewer'
import FormField from "../formField/FormField";
import validate from "validate.js";
import {HelpBlock} from 'react-bootstrap';
import {uploadDoc, verifyDoc} from '../../actions/kyc';

const DOC_TYPES = {
    ownershipStructure: 'Ownership Structure',
    resolution: 'Resolution',
    cpicDocument: 'CIPC Document'
};

export const EntityDocsComponent = React.forwardRef((props, ref) => {

    const [documentType, setDocumentType] = useState('');
    const [entityDocs, setEntityDocs] = useState(props.entityDocs);
    const [showDocument, setShowDocument] = useState(false);
    const [errors, setErrors] = useState({});
    const [fileId, setFileId] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        setEntityDocs(props.entityDocs);
    }, [props])

    useImperativeHandle(ref, () => {
        return {
            validateDocs: validateDocs
        };
    });

    const findDoc = (entityDocs, documentType) => {
        const docFound = _.find(entityDocs, (doc) => (doc.documentType == documentType));
        return docFound ? docFound : {}
    };

    const onHandleUpload = (base64, inProgress, onComplete, onSuccess) => {
        const handleOnSuccess = (documentId, data) => {
            onSuccess && onSuccess(documentId);
        };
        dispatch(uploadDoc(base64, handleOnSuccess, null, inProgress, onComplete));
    };

    const onHandleRemoveDocument = (documentType) => {
        const {onRemoveDocument} = props;
        onRemoveDocument && onRemoveDocument(documentType);
    };

    const handleResetError = (attribute) => {
        setErrors({errors: _.extend({}, errors, {[attribute]: null})})
    };

    const validateDocs = () => {

        const options = {fullMessages: false};

        const checkDocument = (documentType) => {
            const doc = findDoc(entityDocs, documentType);
            return doc && doc.verified ? doc : null;
        };

        const constraints = {
            [DOC_TYPES.resolution]: {presence: true},
            [DOC_TYPES.cpicDocument]: {presence: true},
            [DOC_TYPES.ownershipStructure]: {presence: true},
        };
        const errors = validate({
            [DOC_TYPES.resolution]: checkDocument(DOC_TYPES.resolution),
            [DOC_TYPES.cpicDocument]: checkDocument(DOC_TYPES.cpicDocument),
            [DOC_TYPES.ownershipStructure]: checkDocument(DOC_TYPES.ownershipStructure),

        }, constraints, options);
        setErrors(errors);
        return _.isEmpty(errors);
    };

    const onHandleVerify = (documentId, documentType, onSuccess) => {
        const {onUploadComplete} = props;

        const onHandleSuccess = () => {

            onHandleCloseDocument();
            onSuccess && onSuccess();
            onUploadComplete && onUploadComplete(documentType, documentId);
        };
        if (props.applicationId) {
            dispatch(verifyDoc(entityDocs, documentType, props.applicationId, documentId, onHandleSuccess));
        } else {
            onHandleSuccess();
        }
    };

    const handleViewDocument = (event, fileId, documentType) => {
        setShowDocument(true);
        setDocumentType(documentType);
        setFileId(fileId);
    };

    const onHandleCloseDocument = () => {
        setShowDocument(false);
    };

    const renderDocument = () => {
        const {isUpload} = props;

        if (!showDocument) return null;
        return (
            <Popup onClose={onHandleCloseDocument}>
                <DocumentViewer
                    isUpload={isUpload}
                    fileId={fileId}
                    documentType={documentType}
                    onUpload={onHandleUpload}
                    onRemove={onHandleRemoveDocument}
                    onVerify={onHandleVerify}
                    onClose={onHandleCloseDocument}
                />
            </Popup>
        )
    }


    const shareholderDoc = findDoc(entityDocs, DOC_TYPES.ownershipStructure);
    const proofOfAuthDoc = findDoc(entityDocs, DOC_TYPES.resolution);
    const proofOfLegalDoc = findDoc(entityDocs, DOC_TYPES.cpicDocument);

    return (
        <div>
            <div className="flexColumn">
                <div className="card-container-form">
                    <div className="section-title">
                        Entity Documentation
                        <br/>
                        <HelpBlock>
                            <small>
                                Please review and verify that the documents are their latest copies.
                            </small>
                        </HelpBlock>
                    </div>
                    <hr style={{marginTop: 10, marginBottom: 10}}/>

                    <FormField
                        className="form-group"
                        error={errors && errors[DOC_TYPES.cpicDocument] ? ['Document Required'] : ''}
                    >
                        <div className="flexRow">
                            <div className="col-md-6 col-sm-4  col-xs-4" style={{padding: 0}}>
                                <label className=" blackText">Proof of Legal Existence </label>
                                <label
                                    className="form-group"
                                    id="proofOfLegalExistence"
                                />
                            </div>

                            <div className="col-md-3  col-sm-4  col-xs-4" style={{padding: 0}}>
                                <label
                                    className="form-group boldText"
                                    id="proofOfLegalExistenceStatus"
                                /> {proofOfLegalDoc.verified ? (props.isUpload ? 'Confirmed' : 'Verified') : (props.isUpload ? 'Unconfirmed' : 'Unverified')}
                            </div>

                            <div className="col-md-3  col-sm-4  col-xs-4" style={{padding: 0}}>
                                <div
                                    className="flat-button-primary"
                                    onClick={(event) => {
                                        errors && errors[DOC_TYPES.cpicDocument] && handleResetError(DOC_TYPES.cpicDocument);
                                        handleViewDocument(event, proofOfLegalDoc.documentId, DOC_TYPES.cpicDocument)
                                    }}
                                >{props.isUpload ? 'Upload' : 'Verify'} <i className="fa fa-angle-right fa-lg"/>
                                </div>
                            </div>
                        </div>
                    </FormField>
                    <hr style={{marginTop: 10, marginBottom: 10}}/>

                    <FormField
                        className="form-group"
                        error={errors && errors[DOC_TYPES.resolution] ? ['Document Required'] : ''}
                    >
                        <div className="flexRow">
                            <div className="col-md-6  col-sm-4 col-xs-4" style={{padding: 0}}>
                                <label className=" blackText">Proof of Authorised Individuals </label>
                                <label className="form-group" id="proofOfLegalExistence"/>
                            </div>

                            <div className="col-md-3  col-sm-4 col-xs-4" style={{padding: 0}}>
                                <label className="form-group" id="proofOfLegalExistenceStatus"
                                /> {proofOfAuthDoc.verified ? (props.isUpload ? 'Confirmed' : 'Verified') : (props.isUpload ? 'Unconfirmed' : 'Unverified')}
                            </div>

                            <div className="col-md-3 col-sm-4  col-xs-4" style={{padding: 0}}>
                                <div
                                    className="flat-button-primary"
                                    onClick={(event) => {
                                        errors && errors[DOC_TYPES.resolution] && handleResetError(DOC_TYPES.resolution);
                                        handleViewDocument(event, proofOfAuthDoc.documentId, DOC_TYPES.resolution)
                                    }}
                                >{props.isUpload ? 'Upload' : 'Verify'} <i className="fa fa-angle-right fa-lg"/>
                                </div>
                            </div>
                        </div>
                    </FormField>

                    <hr style={{marginTop: 10, marginBottom: 10}}/>
                    <FormField
                        className="form-group"
                        error={errors && errors[DOC_TYPES.ownershipStructure] ? ['Document Required'] : ''}
                    >
                        <div className="flexRow">
                            <div className="col-md-6 col-sm-4 col-xs-4" style={{padding: 0}}>
                                <label className=" blackText">Shareholder Structure</label>
                                <label
                                    className="form-group"
                                    id="proofOfLegalExistence"
                                />
                            </div>
                            <div className="col-md-3  col-sm-4 col-xs-4" style={{padding: 0}}>
                                <label
                                    className="form-group"
                                    id="proofOfLegalExistenceStatus"
                                /> {shareholderDoc.verified ? (props.isUpload ? 'Confirmed' : 'Verified') : (props.isUpload ? 'Unconfirmed' : 'Unverified')}
                            </div>
                            <div className="col-md-3 col-sm-4  col-xs-4 " style={{padding: 0}}>
                                <div
                                    className="flat-button-primary"
                                    onClick={(event) => {
                                        errors && errors[DOC_TYPES.ownershipStructure] && handleResetError(DOC_TYPES.ownershipStructure);
                                        handleViewDocument(event, shareholderDoc.documentId, DOC_TYPES.ownershipStructure)
                                    }}
                                >{props.isUpload ? 'Upload' : 'Verify'} <i className="fa fa-angle-right fa-lg"/>
                                </div>
                            </div>
                        </div>
                    </FormField>
                </div>
            </div>
            {renderDocument()}
        </div>
    );
});
export default EntityDocsComponent;


